import Vue from "vue"

export default {
    namespaced: true,
    state() {
        return {
            company: null,
            location: null,
            locationGroup: null,
            deviceGroup: null,
            device: null,
            isVisible: false,
            isLoading: true,
            menu: [],
            activeMenuItem: null,
            lastRootRoute: null,
            breadcrumbs: [],
            routes: {},
            breadcrumbPaths: [],
            homeHref: "",
            isInputFocused: false,
            flatBreadcrumbData: [],
        }
    },
    actions: {
        toggleVisibility({ commit }) {
            commit("toggleVisibility")
        },
        setSidebarVisibility({ commit }, value) {
            commit("setSidebarVisibility", value)
        },
        setActiveMenuItem({ commit, state }, item) {
            const { data } = item

            commit("setActiveMenuItem", item)

            if (data?.location?.id !== state.location?.id) {
                commit("setLocation", data?.location ?? null)
            }

            if (data?.locationGroup?.id !== state.locationGroup?.id) {
                commit("setLocationGroup", data?.locationGroup ?? null)
            }

            if (data?.deviceGroup?.id !== state.deviceGroup?.id) {
                commit("setDeviceGroup", data?.deviceGroup ?? null)
            }

            if (data?.device?.id !== state.device?.id) {
                commit("setDevice", data?.device ?? null)
            }
        },
        setLocationGroup({ commit }, value) {
            commit("setLocationGroup", value)
        },
        setDeviceGroup({ commit }, value) {
            commit("setDeviceGroup", value)
        },
        setLocation({ commit }, value) {
            commit("setLocation", value)
        },
        setCompany({ commit }, value) {
            commit("setCompany", value)
        },
        async fetchMenu({ commit, getters, dispatch }, companyId) {
            commit("startLoading")

            let url = "/menu"

            if (companyId) {
                url = "/menu/" + companyId
            }

            return Vue.axios
                .get(url)
                .then(async (response) => {
                    let menu = response.data.data.structure
                    const rootGroup = response.data.data.company?.rootGroup

                    commit("setSidebarMenu", menu)
                    commit("setHomeHref", menu[0]?.href)

                    if (menu.length > 0) {
                        dispatch(
                            "breadcrumbs/createFlatBreadcrumbData",
                            { menu, rootGroup },
                            { root: true },
                        )
                    }
                })
                .finally(() => {
                    commit("stopLoading")
                })
        },
        addRoute({ commit }, item) {
            commit("addRoute", item)
        },
        setLoading({ commit }, item) {
            if (item) {
                commit("startLoading")
            } else {
                commit("stopLoading")
            }
        },
        setMenu({ commit }, menu) {
            commit("setSidebarMenu", menu)
        },
        setInputFocused({ commit }, value) {
            commit("setInputFocused", value)
        },
    },
    mutations: {
        setSidebarMenu(state, menu) {
            state.menu = menu
        },
        startLoading(state) {
            state.isLoading = true
        },
        stopLoading(state) {
            state.isLoading = false
        },
        toggleVisibility(state) {
            state.isVisible = !state.isVisible
        },
        setSidebarVisibility(state, value) {
            state.isVisible = value
        },
        setLastRootRoute(state, value) {
            state.lastRootRoute = value
        },
        setCompany(state, value) {
            if (value === undefined) {
                value = null
            }

            state.company = value
        },
        setLocation(state, value) {
            state.location = value
        },
        setLocationGroup(state, value) {
            state.locationGroup = value
        },
        setDeviceGroup(state, value) {
            state.deviceGroup = value
        },
        setActiveMenuItem(state, item) {
            state.activeMenuItem = item
        },
        setDevice(state, value) {
            state.device = value
        },
        addRoute(state, item) {
            const key = item.href
            state.routes[key] = item
        },
        setBreadcrumbs(state, breadcrumbs) {
            state.breadcrumbs = breadcrumbs
        },
        setHomeHref(state, href) {
            state.homeHref = href
        },
        setInputFocused(state, value) {
            state.isInputFocused = value
        },
    },
    getters: {
        isOnMobile() {
            return window.innerWidth <= 768
        },
        isSidebarVisible(state) {
            return state.isVisible
        },
        isSidebarLoading(state) {
            return state.isLoading
        },
        sidebarMenu(state) {
            return state.menu
        },
        company(state) {
            return state.company
        },
        location(state) {
            return state.location
        },
        locationGroup(state) {
            return state.locationGroup
        },
        deviceGroup(state) {
            return state.deviceGroup
        },
        device(state) {
            return state.device
        },
        deviceId(state) {
            return state?.device?.id
        },
        locationId(state) {
            return state?.location?.id
        },
        companyId(state) {
            return state?.company?.id
        },
        lastRootRoute(state) {
            return state.lastRootRoute
        },
        activeMenuItem(state) {
            return state.activeMenuItem
        },
        breadcrumbPaths(state) {
            return state.breadcrumbs
        },
        routes(state) {
            return state.routes
        },
        homeHref(state) {
            return state.homeHref
        },
        isInputFocused(state) {
            return state.isInputFocused
        },
    },
}
